function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "white"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 188,
  cy: 105,
  r: 15
}), /*#__PURE__*/React.createElement("path", {
  d: "m376 36.213v38.787h38.787z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m188 150c-19.392 0-35.348 14.996-36.88 34h73.76c-1.532-19.004-17.488-34-36.88-34z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m451.041 68.828v-53.828c0-8.284-6.716-15-15-15h-53.828z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m451 105h-90c-8.284 0-15-6.716-15-15v-90h-270.041c-8.284 0-15 6.716-15 15v482c0 8.284 6.716 15 15 15h360.082c8.284 0 15-6.716 15-15v-392.002c-.014.001-.027.002-.041.002zm-330 82c0-23.401 12.068-44.026 30.298-56.012-5.217-7.346-8.298-16.312-8.298-25.988 0-24.813 20.187-45 45-45s45 20.187 45 45c0 9.677-3.081 18.642-8.298 25.989 18.23 11.985 30.298 32.61 30.298 56.011v12c0 8.284-6.716 15-15 15h-104c-8.284 0-15-6.716-15-15zm119.988 267h-104.988c-8.284 0-15-6.716-15-15s6.716-15 15-15h104.988c8.284 0 15 6.716 15 15s-6.716 15-15 15zm135.009-60h-239.997c-8.284 0-15-6.716-15-15s6.716-15 15-15h239.997c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-60h-239.997c-8.284 0-15-6.716-15-15s6.716-15 15-15h239.997c8.284 0 15 6.716 15 15s-6.716 15-15 15zm0-60h-239.997c-8.284 0-15-6.716-15-15s6.716-15 15-15h239.997c8.284 0 15 6.716 15 15s-6.716 15-15 15z"
}));

var SvgResume = function SvgResume(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 80,
    viewBox: "0 0 512 512",
    width: 30,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResume, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resume.26bd5b6e.svg";
export { ForwardRef as ReactComponent };